// extracted by mini-css-extract-plugin
export default {"button":"edit_button-module___button___baa4bd90"};